/**
 * Used to scroll to desired postion / without any value provided
 * as scrollToTop
 *
 * @param x
 * @param y
 */
export function scrollTo(x: number = 0, y: number = 0): void {
  window.scrollTo(x, y);
}



// WEBPACK FOOTER //
// ./src/lib/utils/scroll.ts